import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { t } from 'react-switch-lang';

const ContactReCaptcha = React.forwardRef(({ onErrored }, ref) => (
  <>
    <div className="google-recaptcha-disclaimer">
      <p>{t('Recaptcha_Disclaimer_Lbl')}</p>
    </div>
    <ReCAPTCHA
      style={{ display: 'none' }}
      ref={ref}
      size="invisible"
      sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
      onErrored={onErrored}
    />
  </>
));

ContactReCaptcha.displayName = 'ContactReCaptcha';

export default ContactReCaptcha;
